import React from 'react'
import ReactDOM from 'react-dom/client'

import { Routes } from './layers/Routes'
import { Storage } from './layers/Storage'
import { Layout } from './layers/Layout'
import { AuthGuard } from './layers/AuthGuard'
import { ErrorBoundary } from './layers/ErrorBoundary'
import { LocalizedRouter } from './layers/Localization'

ReactDOM.createRoot(document.getElementById('root')).render(
	<ErrorBoundary>
		<Storage>
			<LocalizedRouter>
				<AuthGuard>
					<Layout>
						<Routes />
					</Layout>
				</AuthGuard>
			</LocalizedRouter>
		</Storage>
	</ErrorBoundary>
)